import { call, put, takeEvery } from "redux-saga/effects"

// Crypto Redux States
import { CREATE_APOLICE, UPDATE_APOLICE, DELETE_APOLICE } from "./actionTypes"
import { createApoliceSuccess, createApoliceFail, updateApoliceSuccess, updateApoliceFail, deleteApoliceSuccess, deleteApoliceFail } from "./actions"

//Include Both Helper File with needed methods
import { createApolice, updateApolice, deleteApolice } from "helpers/blopsleads_helper"


// function* fetchApolicesPendentes() {
//   try {
//     const response = yield call(getAPOLICEPendentes)
//     yield put(getApolicesSuccess(response))
//   } catch (error) {
//     yield put(getApolicesFail(error))
//   }
// }

function* onCreateApolice({ payload: data }) {
  try {
      const response = yield call(createApolice, data)

      yield put(createApoliceSuccess(response))
  } catch (error) {
      yield put(createApoliceFail(error))
  }
}

function* onUpdateApolice({ payload: data }) {
  try {
      const response = yield call(updateApolice, data)

      yield put(updateApoliceSuccess(response))
  } catch (error) {
      yield put(updateApoliceFail(error))
  }
}

function* onDeleteApolice({payload: apolice}){
  try {
    const response = yield call(deleteApolice, apolice)

    yield put(deleteApoliceSuccess(response))
  } catch (error) {
    yield put(deleteApoliceFail(error))
  }
}

function* ApoliceSaga() {
  yield takeEvery(CREATE_APOLICE, onCreateApolice)
  yield takeEvery(UPDATE_APOLICE, onUpdateApolice)
  yield takeEvery(DELETE_APOLICE, onDeleteApolice)
}

export default ApoliceSaga
